const Colors = {
    primary: '#1172ba',
    secondary: '#00aea9',
    yellow: '#ffee00',
}

export default Colors
